import React, { useMemo } from 'react';
import SocialShareButtonProps from "./props";
import Button from '../../private/Button';
import ButtonProps from '../../private/Button/props';
import shareIcon from '../../../icons/share-2.svg';
import './styles.scss';

function SocialShareButton(props: SocialShareButtonProps) {
  const buttonProps = useButtonProps(props);
  return (
    <div className="social-share-button"><Button { ...buttonProps } /></div>
  );
}

const useButtonProps = (props: SocialShareButtonProps): ButtonProps => useMemo(() => ({
  onClick: props.onClick,
  classNames: {
    share: true
  },
  Icon: {
    svg: shareIcon,
    alt: props.text
  },
  Label: {
    text: props.text
  },
}), [props]);

export default React.memo(SocialShareButton);
